/* tslint:disable */
/* eslint-disable */
/**
 * blast-viewer API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.1.0-SNAPSHOT
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from './configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from './common';
import type { RequestArgs } from './base';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, BaseAPI, RequiredError, operationServerMap } from './base';

/**
 * 
 * @export
 * @interface ConfigMethodDto
 */
export interface ConfigMethodDto {
    /**
     * 
     * @type {string}
     * @memberof ConfigMethodDto
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof ConfigMethodDto
     */
    'path'?: string;
    /**
     * 
     * @type {number}
     * @memberof ConfigMethodDto
     */
    'lengthMin'?: number;
    /**
     * 
     * @type {number}
     * @memberof ConfigMethodDto
     */
    'lengthMax'?: number;
    /**
     * 
     * @type {number}
     * @memberof ConfigMethodDto
     */
    'threshold'?: number;
    /**
     * 
     * @type {number}
     * @memberof ConfigMethodDto
     */
    'workers'?: number;
}
/**
 * 
 * @export
 * @interface Dates
 */
export interface Dates {
    /**
     * 
     * @type {number}
     * @memberof Dates
     */
    'min'?: number;
    /**
     * 
     * @type {number}
     * @memberof Dates
     */
    'max'?: number;
}
/**
 * 
 * @export
 * @interface EventsDto
 */
export interface EventsDto {
    /**
     * 
     * @type {string}
     * @memberof EventsDto
     */
    'stepName'?: string;
    /**
     * 
     * @type {number}
     * @memberof EventsDto
     */
    'time'?: number;
    /**
     * 
     * @type {Array<string>}
     * @memberof EventsDto
     */
    'parameters'?: Array<string>;
}
/**
 * 
 * @export
 * @interface MethodsDto
 */
export interface MethodsDto {
    /**
     * 
     * @type {string}
     * @memberof MethodsDto
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof MethodsDto
     */
    'path'?: string;
    /**
     * 
     * @type {number}
     * @memberof MethodsDto
     */
    'lengthMax'?: number;
    /**
     * 
     * @type {number}
     * @memberof MethodsDto
     */
    'lengthMin'?: number;
    /**
     * 
     * @type {number}
     * @memberof MethodsDto
     */
    'thresholdMax'?: number;
    /**
     * 
     * @type {number}
     * @memberof MethodsDto
     */
    'thresholdMin'?: number;
    /**
     * 
     * @type {number}
     * @memberof MethodsDto
     */
    'workers'?: number;
}
/**
 * 
 * @export
 * @interface ResultsDto
 */
export interface ResultsDto {
    /**
     * 
     * @type {string}
     * @memberof ResultsDto
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResultsDto
     */
    'periodMin'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResultsDto
     */
    'periodMax'?: string;
    /**
     * 
     * @type {TileInfoDto}
     * @memberof ResultsDto
     */
    'tile'?: TileInfoDto;
    /**
     * 
     * @type {ConfigMethodDto}
     * @memberof ResultsDto
     */
    'method'?: ConfigMethodDto;
    /**
     * 
     * @type {string}
     * @memberof ResultsDto
     */
    'pid'?: string;
    /**
     * 
     * @type {Array<EventsDto>}
     * @memberof ResultsDto
     */
    'events'?: Array<EventsDto>;
    /**
     * 
     * @type {Array<string>}
     * @memberof ResultsDto
     */
    'files'?: Array<string>;
}
/**
 * 
 * @export
 * @interface TileDto
 */
export interface TileDto {
    /**
     * 
     * @type {number}
     * @memberof TileDto
     */
    'date'?: number;
    /**
     * 
     * @type {Array<number>}
     * @memberof TileDto
     */
    'latitudes'?: Array<number>;
    /**
     * 
     * @type {Array<number>}
     * @memberof TileDto
     */
    'longitudes'?: Array<number>;
    /**
     * 
     * @type {Array<string>}
     * @memberof TileDto
     */
    'values'?: Array<string>;
}
/**
 * 
 * @export
 * @interface TileInfoDto
 */
export interface TileInfoDto {
    /**
     * 
     * @type {string}
     * @memberof TileInfoDto
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof TileInfoDto
     */
    'location'?: string;
    /**
     * 
     * @type {string}
     * @memberof TileInfoDto
     */
    'path'?: string;
    /**
     * 
     * @type {string}
     * @memberof TileInfoDto
     */
    'params'?: string;
    /**
     * 
     * @type {Dates}
     * @memberof TileInfoDto
     */
    'date'?: Dates;
}

/**
 * FileManagerCtrlApi - axios parameter creator
 * @export
 */
export const FileManagerCtrlApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Read Burst File
         * @param {string} [path] 
         * @param {number} [tile] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiFilesBurstTileGet: async (path?: string, tile?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/files/burst-tile`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (path !== undefined) {
                localVarQueryParameter['path'] = path;
            }

            if (tile !== undefined) {
                localVarQueryParameter['tile'] = tile;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Days
         * @param {string} [path] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiFilesDaysGet: async (path?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/files/days`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (path !== undefined) {
                localVarQueryParameter['path'] = path;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete Run
         * @param {string} [path] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiFilesDelete: async (path?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/files`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (path !== undefined) {
                localVarQueryParameter['path'] = path;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary List Files
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiFilesGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/files`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Heatmap
         * @param {string} [path] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiFilesHeatmapGet: async (path?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/files/heatmap`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (path !== undefined) {
                localVarQueryParameter['path'] = path;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get File
         * @param {string} [file] 
         * @param {string} [path] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiFilesImageGet: async (file?: string, path?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/files/image`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (file !== undefined) {
                localVarQueryParameter['file'] = file;
            }

            if (path !== undefined) {
                localVarQueryParameter['path'] = path;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary List Files
         * @param {string} [path] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiFilesLsGet: async (path?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/files/ls`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (path !== undefined) {
                localVarQueryParameter['path'] = path;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Read File
         * @param {string} [path] 
         * @param {number} [tile] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiFilesRawTileGet: async (path?: string, tile?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/files/raw-tile`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (path !== undefined) {
                localVarQueryParameter['path'] = path;
            }

            if (tile !== undefined) {
                localVarQueryParameter['tile'] = tile;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get File Result
         * @param {string} [path] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiFilesResultGet: async (path?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/files/result`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (path !== undefined) {
                localVarQueryParameter['path'] = path;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Series
         * @param {string} [path] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiFilesSeriesGet: async (path?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/files/series`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (path !== undefined) {
                localVarQueryParameter['path'] = path;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * FileManagerCtrlApi - functional programming interface
 * @export
 */
export const FileManagerCtrlApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = FileManagerCtrlApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Read Burst File
         * @param {string} [path] 
         * @param {number} [tile] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiFilesBurstTileGet(path?: string, tile?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TileDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiFilesBurstTileGet(path, tile, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FileManagerCtrlApi.apiFilesBurstTileGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get Days
         * @param {string} [path] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiFilesDaysGet(path?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiFilesDaysGet(path, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FileManagerCtrlApi.apiFilesDaysGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Delete Run
         * @param {string} [path] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiFilesDelete(path?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiFilesDelete(path, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FileManagerCtrlApi.apiFilesDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary List Files
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiFilesGet(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<{ [key: string]: ResultsDto; }>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiFilesGet(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FileManagerCtrlApi.apiFilesGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get Heatmap
         * @param {string} [path] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiFilesHeatmapGet(path?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiFilesHeatmapGet(path, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FileManagerCtrlApi.apiFilesHeatmapGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get File
         * @param {string} [file] 
         * @param {string} [path] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiFilesImageGet(file?: string, path?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiFilesImageGet(file, path, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FileManagerCtrlApi.apiFilesImageGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary List Files
         * @param {string} [path] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiFilesLsGet(path?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<string>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiFilesLsGet(path, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FileManagerCtrlApi.apiFilesLsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Read File
         * @param {string} [path] 
         * @param {number} [tile] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiFilesRawTileGet(path?: string, tile?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TileDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiFilesRawTileGet(path, tile, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FileManagerCtrlApi.apiFilesRawTileGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get File Result
         * @param {string} [path] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiFilesResultGet(path?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResultsDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiFilesResultGet(path, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FileManagerCtrlApi.apiFilesResultGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get Series
         * @param {string} [path] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiFilesSeriesGet(path?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiFilesSeriesGet(path, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FileManagerCtrlApi.apiFilesSeriesGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * FileManagerCtrlApi - factory interface
 * @export
 */
export const FileManagerCtrlApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = FileManagerCtrlApiFp(configuration)
    return {
        /**
         * 
         * @summary Read Burst File
         * @param {string} [path] 
         * @param {number} [tile] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiFilesBurstTileGet(path?: string, tile?: number, options?: RawAxiosRequestConfig): AxiosPromise<TileDto> {
            return localVarFp.apiFilesBurstTileGet(path, tile, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Days
         * @param {string} [path] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiFilesDaysGet(path?: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.apiFilesDaysGet(path, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete Run
         * @param {string} [path] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiFilesDelete(path?: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.apiFilesDelete(path, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary List Files
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiFilesGet(options?: RawAxiosRequestConfig): AxiosPromise<{ [key: string]: ResultsDto; }> {
            return localVarFp.apiFilesGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Heatmap
         * @param {string} [path] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiFilesHeatmapGet(path?: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.apiFilesHeatmapGet(path, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get File
         * @param {string} [file] 
         * @param {string} [path] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiFilesImageGet(file?: string, path?: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.apiFilesImageGet(file, path, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary List Files
         * @param {string} [path] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiFilesLsGet(path?: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<string>> {
            return localVarFp.apiFilesLsGet(path, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Read File
         * @param {string} [path] 
         * @param {number} [tile] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiFilesRawTileGet(path?: string, tile?: number, options?: RawAxiosRequestConfig): AxiosPromise<TileDto> {
            return localVarFp.apiFilesRawTileGet(path, tile, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get File Result
         * @param {string} [path] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiFilesResultGet(path?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResultsDto> {
            return localVarFp.apiFilesResultGet(path, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Series
         * @param {string} [path] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiFilesSeriesGet(path?: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.apiFilesSeriesGet(path, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * FileManagerCtrlApi - object-oriented interface
 * @export
 * @class FileManagerCtrlApi
 * @extends {BaseAPI}
 */
export class FileManagerCtrlApi extends BaseAPI {
    /**
     * 
     * @summary Read Burst File
     * @param {string} [path] 
     * @param {number} [tile] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FileManagerCtrlApi
     */
    public apiFilesBurstTileGet(path?: string, tile?: number, options?: RawAxiosRequestConfig) {
        return FileManagerCtrlApiFp(this.configuration).apiFilesBurstTileGet(path, tile, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Days
     * @param {string} [path] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FileManagerCtrlApi
     */
    public apiFilesDaysGet(path?: string, options?: RawAxiosRequestConfig) {
        return FileManagerCtrlApiFp(this.configuration).apiFilesDaysGet(path, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete Run
     * @param {string} [path] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FileManagerCtrlApi
     */
    public apiFilesDelete(path?: string, options?: RawAxiosRequestConfig) {
        return FileManagerCtrlApiFp(this.configuration).apiFilesDelete(path, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary List Files
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FileManagerCtrlApi
     */
    public apiFilesGet(options?: RawAxiosRequestConfig) {
        return FileManagerCtrlApiFp(this.configuration).apiFilesGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Heatmap
     * @param {string} [path] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FileManagerCtrlApi
     */
    public apiFilesHeatmapGet(path?: string, options?: RawAxiosRequestConfig) {
        return FileManagerCtrlApiFp(this.configuration).apiFilesHeatmapGet(path, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get File
     * @param {string} [file] 
     * @param {string} [path] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FileManagerCtrlApi
     */
    public apiFilesImageGet(file?: string, path?: string, options?: RawAxiosRequestConfig) {
        return FileManagerCtrlApiFp(this.configuration).apiFilesImageGet(file, path, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary List Files
     * @param {string} [path] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FileManagerCtrlApi
     */
    public apiFilesLsGet(path?: string, options?: RawAxiosRequestConfig) {
        return FileManagerCtrlApiFp(this.configuration).apiFilesLsGet(path, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Read File
     * @param {string} [path] 
     * @param {number} [tile] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FileManagerCtrlApi
     */
    public apiFilesRawTileGet(path?: string, tile?: number, options?: RawAxiosRequestConfig) {
        return FileManagerCtrlApiFp(this.configuration).apiFilesRawTileGet(path, tile, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get File Result
     * @param {string} [path] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FileManagerCtrlApi
     */
    public apiFilesResultGet(path?: string, options?: RawAxiosRequestConfig) {
        return FileManagerCtrlApiFp(this.configuration).apiFilesResultGet(path, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Series
     * @param {string} [path] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FileManagerCtrlApi
     */
    public apiFilesSeriesGet(path?: string, options?: RawAxiosRequestConfig) {
        return FileManagerCtrlApiFp(this.configuration).apiFilesSeriesGet(path, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * SimulationManagerCtrlApi - axios parameter creator
 * @export
 */
export const SimulationManagerCtrlApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Add Event Api
         * @param {EventsDto} eventsDto 
         * @param {string} [path] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiRunEventPost: async (eventsDto: EventsDto, path?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'eventsDto' is not null or undefined
            assertParamExists('apiRunEventPost', 'eventsDto', eventsDto)
            const localVarPath = `/api/run/event`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (path !== undefined) {
                localVarQueryParameter['path'] = path;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(eventsDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Init Sim
         * @param {ResultsDto} resultsDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiRunPost: async (resultsDto: ResultsDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'resultsDto' is not null or undefined
            assertParamExists('apiRunPost', 'resultsDto', resultsDto)
            const localVarPath = `/api/run`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(resultsDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Start Sim Run
         * @param {string} [path] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiRunStartGet: async (path?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/run/start`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (path !== undefined) {
                localVarQueryParameter['path'] = path;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Sim Status
         * @param {string} [path] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiRunStatusGet: async (path?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/run/status`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (path !== undefined) {
                localVarQueryParameter['path'] = path;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Stop Sim Run
         * @param {string} [path] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiRunStopGet: async (path?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/run/stop`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (path !== undefined) {
                localVarQueryParameter['path'] = path;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * SimulationManagerCtrlApi - functional programming interface
 * @export
 */
export const SimulationManagerCtrlApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = SimulationManagerCtrlApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Add Event Api
         * @param {EventsDto} eventsDto 
         * @param {string} [path] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiRunEventPost(eventsDto: EventsDto, path?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiRunEventPost(eventsDto, path, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SimulationManagerCtrlApi.apiRunEventPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Init Sim
         * @param {ResultsDto} resultsDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiRunPost(resultsDto: ResultsDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiRunPost(resultsDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SimulationManagerCtrlApi.apiRunPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Start Sim Run
         * @param {string} [path] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiRunStartGet(path?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiRunStartGet(path, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SimulationManagerCtrlApi.apiRunStartGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get Sim Status
         * @param {string} [path] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiRunStatusGet(path?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResultsDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiRunStatusGet(path, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SimulationManagerCtrlApi.apiRunStatusGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Stop Sim Run
         * @param {string} [path] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiRunStopGet(path?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiRunStopGet(path, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SimulationManagerCtrlApi.apiRunStopGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * SimulationManagerCtrlApi - factory interface
 * @export
 */
export const SimulationManagerCtrlApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = SimulationManagerCtrlApiFp(configuration)
    return {
        /**
         * 
         * @summary Add Event Api
         * @param {EventsDto} eventsDto 
         * @param {string} [path] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiRunEventPost(eventsDto: EventsDto, path?: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.apiRunEventPost(eventsDto, path, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Init Sim
         * @param {ResultsDto} resultsDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiRunPost(resultsDto: ResultsDto, options?: RawAxiosRequestConfig): AxiosPromise<string> {
            return localVarFp.apiRunPost(resultsDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Start Sim Run
         * @param {string} [path] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiRunStartGet(path?: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.apiRunStartGet(path, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Sim Status
         * @param {string} [path] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiRunStatusGet(path?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResultsDto> {
            return localVarFp.apiRunStatusGet(path, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Stop Sim Run
         * @param {string} [path] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiRunStopGet(path?: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.apiRunStopGet(path, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * SimulationManagerCtrlApi - object-oriented interface
 * @export
 * @class SimulationManagerCtrlApi
 * @extends {BaseAPI}
 */
export class SimulationManagerCtrlApi extends BaseAPI {
    /**
     * 
     * @summary Add Event Api
     * @param {EventsDto} eventsDto 
     * @param {string} [path] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SimulationManagerCtrlApi
     */
    public apiRunEventPost(eventsDto: EventsDto, path?: string, options?: RawAxiosRequestConfig) {
        return SimulationManagerCtrlApiFp(this.configuration).apiRunEventPost(eventsDto, path, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Init Sim
     * @param {ResultsDto} resultsDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SimulationManagerCtrlApi
     */
    public apiRunPost(resultsDto: ResultsDto, options?: RawAxiosRequestConfig) {
        return SimulationManagerCtrlApiFp(this.configuration).apiRunPost(resultsDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Start Sim Run
     * @param {string} [path] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SimulationManagerCtrlApi
     */
    public apiRunStartGet(path?: string, options?: RawAxiosRequestConfig) {
        return SimulationManagerCtrlApiFp(this.configuration).apiRunStartGet(path, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Sim Status
     * @param {string} [path] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SimulationManagerCtrlApi
     */
    public apiRunStatusGet(path?: string, options?: RawAxiosRequestConfig) {
        return SimulationManagerCtrlApiFp(this.configuration).apiRunStatusGet(path, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Stop Sim Run
     * @param {string} [path] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SimulationManagerCtrlApi
     */
    public apiRunStopGet(path?: string, options?: RawAxiosRequestConfig) {
        return SimulationManagerCtrlApiFp(this.configuration).apiRunStopGet(path, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * UtilManagerCtrlApi - axios parameter creator
 * @export
 */
export const UtilManagerCtrlApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary List Methods 2
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUtilMethodsGet: async (origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/util/methods`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary List Tiles
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUtilTilesGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/util/tiles`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary List Tiles
         * @param {File} body 
         * @param {number} [chunk] 
         * @param {number} [nbChunk] 
         * @param {string} [path] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUtilUploadTilesPost: async (body: File, chunk?: number, nbChunk?: number, path?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'body' is not null or undefined
            assertParamExists('apiUtilUploadTilesPost', 'body', body)
            const localVarPath = `/api/util/upload/tiles`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (chunk !== undefined) {
                localVarQueryParameter['chunk'] = chunk;
            }

            if (nbChunk !== undefined) {
                localVarQueryParameter['nbChunk'] = nbChunk;
            }

            if (path !== undefined) {
                localVarQueryParameter['path'] = path;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/octet-stream';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * UtilManagerCtrlApi - functional programming interface
 * @export
 */
export const UtilManagerCtrlApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = UtilManagerCtrlApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary List Methods 2
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiUtilMethodsGet(origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<MethodsDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiUtilMethodsGet(origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UtilManagerCtrlApi.apiUtilMethodsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary List Tiles
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiUtilTilesGet(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<TileInfoDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiUtilTilesGet(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UtilManagerCtrlApi.apiUtilTilesGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary List Tiles
         * @param {File} body 
         * @param {number} [chunk] 
         * @param {number} [nbChunk] 
         * @param {string} [path] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiUtilUploadTilesPost(body: File, chunk?: number, nbChunk?: number, path?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiUtilUploadTilesPost(body, chunk, nbChunk, path, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UtilManagerCtrlApi.apiUtilUploadTilesPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * UtilManagerCtrlApi - factory interface
 * @export
 */
export const UtilManagerCtrlApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = UtilManagerCtrlApiFp(configuration)
    return {
        /**
         * 
         * @summary List Methods 2
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUtilMethodsGet(origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<MethodsDto>> {
            return localVarFp.apiUtilMethodsGet(origin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary List Tiles
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUtilTilesGet(options?: RawAxiosRequestConfig): AxiosPromise<Array<TileInfoDto>> {
            return localVarFp.apiUtilTilesGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary List Tiles
         * @param {File} body 
         * @param {number} [chunk] 
         * @param {number} [nbChunk] 
         * @param {string} [path] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUtilUploadTilesPost(body: File, chunk?: number, nbChunk?: number, path?: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.apiUtilUploadTilesPost(body, chunk, nbChunk, path, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * UtilManagerCtrlApi - object-oriented interface
 * @export
 * @class UtilManagerCtrlApi
 * @extends {BaseAPI}
 */
export class UtilManagerCtrlApi extends BaseAPI {
    /**
     * 
     * @summary List Methods 2
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UtilManagerCtrlApi
     */
    public apiUtilMethodsGet(origin?: string, options?: RawAxiosRequestConfig) {
        return UtilManagerCtrlApiFp(this.configuration).apiUtilMethodsGet(origin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary List Tiles
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UtilManagerCtrlApi
     */
    public apiUtilTilesGet(options?: RawAxiosRequestConfig) {
        return UtilManagerCtrlApiFp(this.configuration).apiUtilTilesGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary List Tiles
     * @param {File} body 
     * @param {number} [chunk] 
     * @param {number} [nbChunk] 
     * @param {string} [path] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UtilManagerCtrlApi
     */
    public apiUtilUploadTilesPost(body: File, chunk?: number, nbChunk?: number, path?: string, options?: RawAxiosRequestConfig) {
        return UtilManagerCtrlApiFp(this.configuration).apiUtilUploadTilesPost(body, chunk, nbChunk, path, options).then((request) => request(this.axios, this.basePath));
    }
}



